module.exports = __webpack_public_path__ + "static/img/imlerith.8496444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/imlerith.png
// module id = NAr3
// module chunks = 0